/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RadiantRouteImport } from './routes/radiant'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as OrgIdRouteImport } from './routes/$orgId'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrgIdIndexRouteImport } from './routes/$orgId.index'
import { Route as RadiantTenantsRouteImport } from './routes/radiant.tenants'
import { Route as OrgIdSettingsRouteImport } from './routes/$orgId.settings'
import { Route as OrgIdSearchRouteImport } from './routes/$orgId.search'
import { Route as OrgIdReportsRouteImport } from './routes/$orgId.reports'
import { Route as OrgIdOnboardingRouteImport } from './routes/$orgId.onboarding'
import { Route as OrgIdInboxRouteImport } from './routes/$orgId.inbox'
import { Route as OrgIdFleetRouteImport } from './routes/$orgId.fleet'
import { Route as OrgIdCommissioningRouteImport } from './routes/$orgId.commissioning'
import { Route as OrgIdAnalyzeRouteImport } from './routes/$orgId.analyze'
import { Route as OrgIdAnalyzeIndexRouteImport } from './routes/$orgId.analyze.index'
import { Route as RadiantTenantsNewRouteImport } from './routes/radiant.tenants.new'
import { Route as RadiantTenantsIdRouteImport } from './routes/radiant.tenants.$id'
import { Route as OrgIdSitesNewRouteImport } from './routes/$orgId.sites.new'
import { Route as OrgIdSensorsNewRouteImport } from './routes/$orgId.sensors.new'
import { Route as OrgIdSensorsIdRouteImport } from './routes/$orgId.sensors.$id'
import { Route as OrgIdAssetsNewRouteImport } from './routes/$orgId.assets.new'
import { Route as OrgIdAssetsIdRouteImport } from './routes/$orgId.assets.$id'
import { Route as OrgIdAnalyzeSessionsRouteImport } from './routes/$orgId.analyze.sessions'
import { Route as OrgIdAlertsIdRouteImport } from './routes/$orgId.alerts.$id'
import { Route as OrgIdAdminUsersRouteImport } from './routes/$orgId.admin.users'
import { Route as OrgIdAdminRolesRouteImport } from './routes/$orgId.admin.roles'
import { Route as OrgIdAdminOrgRouteImport } from './routes/$orgId.admin.org'
import { Route as OrgIdAdminGroupsRouteImport } from './routes/$orgId.admin.groups'
import { Route as OrgIdAdminAuditRouteImport } from './routes/$orgId.admin.audit'

const RadiantRoute = RadiantRouteImport.update({
  id: '/radiant',
  path: '/radiant',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgIdRoute = OrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgIdIndexRoute = OrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgIdRoute,
} as any)
const RadiantTenantsRoute = RadiantTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => RadiantRoute,
} as any)
const OrgIdSettingsRoute = OrgIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdSearchRoute = OrgIdSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdReportsRoute = OrgIdReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdOnboardingRoute = OrgIdOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdInboxRoute = OrgIdInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdFleetRoute = OrgIdFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdCommissioningRoute = OrgIdCommissioningRouteImport.update({
  id: '/commissioning',
  path: '/commissioning',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAnalyzeRoute = OrgIdAnalyzeRouteImport.update({
  id: '/analyze',
  path: '/analyze',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAnalyzeIndexRoute = OrgIdAnalyzeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgIdAnalyzeRoute,
} as any)
const RadiantTenantsNewRoute = RadiantTenantsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => RadiantTenantsRoute,
} as any)
const RadiantTenantsIdRoute = RadiantTenantsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => RadiantTenantsRoute,
} as any)
const OrgIdSitesNewRoute = OrgIdSitesNewRouteImport.update({
  id: '/sites/new',
  path: '/sites/new',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdSensorsNewRoute = OrgIdSensorsNewRouteImport.update({
  id: '/sensors/new',
  path: '/sensors/new',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdSensorsIdRoute = OrgIdSensorsIdRouteImport.update({
  id: '/sensors/$id',
  path: '/sensors/$id',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAssetsNewRoute = OrgIdAssetsNewRouteImport.update({
  id: '/assets/new',
  path: '/assets/new',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAssetsIdRoute = OrgIdAssetsIdRouteImport.update({
  id: '/assets/$id',
  path: '/assets/$id',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAnalyzeSessionsRoute = OrgIdAnalyzeSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => OrgIdAnalyzeRoute,
} as any)
const OrgIdAlertsIdRoute = OrgIdAlertsIdRouteImport.update({
  id: '/alerts/$id',
  path: '/alerts/$id',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAdminUsersRoute = OrgIdAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAdminRolesRoute = OrgIdAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAdminOrgRoute = OrgIdAdminOrgRouteImport.update({
  id: '/admin/org',
  path: '/admin/org',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAdminGroupsRoute = OrgIdAdminGroupsRouteImport.update({
  id: '/admin/groups',
  path: '/admin/groups',
  getParentRoute: () => OrgIdRoute,
} as any)
const OrgIdAdminAuditRoute = OrgIdAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => OrgIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$orgId': typeof OrgIdRouteWithChildren
  '/auth': typeof AuthRoute
  '/invite': typeof InviteRoute
  '/radiant': typeof RadiantRouteWithChildren
  '/$orgId/analyze': typeof OrgIdAnalyzeRouteWithChildren
  '/$orgId/commissioning': typeof OrgIdCommissioningRoute
  '/$orgId/fleet': typeof OrgIdFleetRoute
  '/$orgId/inbox': typeof OrgIdInboxRoute
  '/$orgId/onboarding': typeof OrgIdOnboardingRoute
  '/$orgId/reports': typeof OrgIdReportsRoute
  '/$orgId/search': typeof OrgIdSearchRoute
  '/$orgId/settings': typeof OrgIdSettingsRoute
  '/radiant/tenants': typeof RadiantTenantsRouteWithChildren
  '/$orgId/': typeof OrgIdIndexRoute
  '/$orgId/admin/audit': typeof OrgIdAdminAuditRoute
  '/$orgId/admin/groups': typeof OrgIdAdminGroupsRoute
  '/$orgId/admin/org': typeof OrgIdAdminOrgRoute
  '/$orgId/admin/roles': typeof OrgIdAdminRolesRoute
  '/$orgId/admin/users': typeof OrgIdAdminUsersRoute
  '/$orgId/alerts/$id': typeof OrgIdAlertsIdRoute
  '/$orgId/analyze/sessions': typeof OrgIdAnalyzeSessionsRoute
  '/$orgId/assets/$id': typeof OrgIdAssetsIdRoute
  '/$orgId/assets/new': typeof OrgIdAssetsNewRoute
  '/$orgId/sensors/$id': typeof OrgIdSensorsIdRoute
  '/$orgId/sensors/new': typeof OrgIdSensorsNewRoute
  '/$orgId/sites/new': typeof OrgIdSitesNewRoute
  '/radiant/tenants/$id': typeof RadiantTenantsIdRoute
  '/radiant/tenants/new': typeof RadiantTenantsNewRoute
  '/$orgId/analyze/': typeof OrgIdAnalyzeIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/invite': typeof InviteRoute
  '/radiant': typeof RadiantRouteWithChildren
  '/$orgId/commissioning': typeof OrgIdCommissioningRoute
  '/$orgId/fleet': typeof OrgIdFleetRoute
  '/$orgId/inbox': typeof OrgIdInboxRoute
  '/$orgId/onboarding': typeof OrgIdOnboardingRoute
  '/$orgId/reports': typeof OrgIdReportsRoute
  '/$orgId/search': typeof OrgIdSearchRoute
  '/$orgId/settings': typeof OrgIdSettingsRoute
  '/radiant/tenants': typeof RadiantTenantsRouteWithChildren
  '/$orgId': typeof OrgIdIndexRoute
  '/$orgId/admin/audit': typeof OrgIdAdminAuditRoute
  '/$orgId/admin/groups': typeof OrgIdAdminGroupsRoute
  '/$orgId/admin/org': typeof OrgIdAdminOrgRoute
  '/$orgId/admin/roles': typeof OrgIdAdminRolesRoute
  '/$orgId/admin/users': typeof OrgIdAdminUsersRoute
  '/$orgId/alerts/$id': typeof OrgIdAlertsIdRoute
  '/$orgId/analyze/sessions': typeof OrgIdAnalyzeSessionsRoute
  '/$orgId/assets/$id': typeof OrgIdAssetsIdRoute
  '/$orgId/assets/new': typeof OrgIdAssetsNewRoute
  '/$orgId/sensors/$id': typeof OrgIdSensorsIdRoute
  '/$orgId/sensors/new': typeof OrgIdSensorsNewRoute
  '/$orgId/sites/new': typeof OrgIdSitesNewRoute
  '/radiant/tenants/$id': typeof RadiantTenantsIdRoute
  '/radiant/tenants/new': typeof RadiantTenantsNewRoute
  '/$orgId/analyze': typeof OrgIdAnalyzeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$orgId': typeof OrgIdRouteWithChildren
  '/auth': typeof AuthRoute
  '/invite': typeof InviteRoute
  '/radiant': typeof RadiantRouteWithChildren
  '/$orgId/analyze': typeof OrgIdAnalyzeRouteWithChildren
  '/$orgId/commissioning': typeof OrgIdCommissioningRoute
  '/$orgId/fleet': typeof OrgIdFleetRoute
  '/$orgId/inbox': typeof OrgIdInboxRoute
  '/$orgId/onboarding': typeof OrgIdOnboardingRoute
  '/$orgId/reports': typeof OrgIdReportsRoute
  '/$orgId/search': typeof OrgIdSearchRoute
  '/$orgId/settings': typeof OrgIdSettingsRoute
  '/radiant/tenants': typeof RadiantTenantsRouteWithChildren
  '/$orgId/': typeof OrgIdIndexRoute
  '/$orgId/admin/audit': typeof OrgIdAdminAuditRoute
  '/$orgId/admin/groups': typeof OrgIdAdminGroupsRoute
  '/$orgId/admin/org': typeof OrgIdAdminOrgRoute
  '/$orgId/admin/roles': typeof OrgIdAdminRolesRoute
  '/$orgId/admin/users': typeof OrgIdAdminUsersRoute
  '/$orgId/alerts/$id': typeof OrgIdAlertsIdRoute
  '/$orgId/analyze/sessions': typeof OrgIdAnalyzeSessionsRoute
  '/$orgId/assets/$id': typeof OrgIdAssetsIdRoute
  '/$orgId/assets/new': typeof OrgIdAssetsNewRoute
  '/$orgId/sensors/$id': typeof OrgIdSensorsIdRoute
  '/$orgId/sensors/new': typeof OrgIdSensorsNewRoute
  '/$orgId/sites/new': typeof OrgIdSitesNewRoute
  '/radiant/tenants/$id': typeof RadiantTenantsIdRoute
  '/radiant/tenants/new': typeof RadiantTenantsNewRoute
  '/$orgId/analyze/': typeof OrgIdAnalyzeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$orgId'
    | '/auth'
    | '/invite'
    | '/radiant'
    | '/$orgId/analyze'
    | '/$orgId/commissioning'
    | '/$orgId/fleet'
    | '/$orgId/inbox'
    | '/$orgId/onboarding'
    | '/$orgId/reports'
    | '/$orgId/search'
    | '/$orgId/settings'
    | '/radiant/tenants'
    | '/$orgId/'
    | '/$orgId/admin/audit'
    | '/$orgId/admin/groups'
    | '/$orgId/admin/org'
    | '/$orgId/admin/roles'
    | '/$orgId/admin/users'
    | '/$orgId/alerts/$id'
    | '/$orgId/analyze/sessions'
    | '/$orgId/assets/$id'
    | '/$orgId/assets/new'
    | '/$orgId/sensors/$id'
    | '/$orgId/sensors/new'
    | '/$orgId/sites/new'
    | '/radiant/tenants/$id'
    | '/radiant/tenants/new'
    | '/$orgId/analyze/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/invite'
    | '/radiant'
    | '/$orgId/commissioning'
    | '/$orgId/fleet'
    | '/$orgId/inbox'
    | '/$orgId/onboarding'
    | '/$orgId/reports'
    | '/$orgId/search'
    | '/$orgId/settings'
    | '/radiant/tenants'
    | '/$orgId'
    | '/$orgId/admin/audit'
    | '/$orgId/admin/groups'
    | '/$orgId/admin/org'
    | '/$orgId/admin/roles'
    | '/$orgId/admin/users'
    | '/$orgId/alerts/$id'
    | '/$orgId/analyze/sessions'
    | '/$orgId/assets/$id'
    | '/$orgId/assets/new'
    | '/$orgId/sensors/$id'
    | '/$orgId/sensors/new'
    | '/$orgId/sites/new'
    | '/radiant/tenants/$id'
    | '/radiant/tenants/new'
    | '/$orgId/analyze'
  id:
    | '__root__'
    | '/'
    | '/$orgId'
    | '/auth'
    | '/invite'
    | '/radiant'
    | '/$orgId/analyze'
    | '/$orgId/commissioning'
    | '/$orgId/fleet'
    | '/$orgId/inbox'
    | '/$orgId/onboarding'
    | '/$orgId/reports'
    | '/$orgId/search'
    | '/$orgId/settings'
    | '/radiant/tenants'
    | '/$orgId/'
    | '/$orgId/admin/audit'
    | '/$orgId/admin/groups'
    | '/$orgId/admin/org'
    | '/$orgId/admin/roles'
    | '/$orgId/admin/users'
    | '/$orgId/alerts/$id'
    | '/$orgId/analyze/sessions'
    | '/$orgId/assets/$id'
    | '/$orgId/assets/new'
    | '/$orgId/sensors/$id'
    | '/$orgId/sensors/new'
    | '/$orgId/sites/new'
    | '/radiant/tenants/$id'
    | '/radiant/tenants/new'
    | '/$orgId/analyze/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrgIdRoute: typeof OrgIdRouteWithChildren
  AuthRoute: typeof AuthRoute
  InviteRoute: typeof InviteRoute
  RadiantRoute: typeof RadiantRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/radiant': {
      id: '/radiant'
      path: '/radiant'
      fullPath: '/radiant'
      preLoaderRoute: typeof RadiantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgId': {
      id: '/$orgId'
      path: '/$orgId'
      fullPath: '/$orgId'
      preLoaderRoute: typeof OrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgId/': {
      id: '/$orgId/'
      path: '/'
      fullPath: '/$orgId/'
      preLoaderRoute: typeof OrgIdIndexRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/radiant/tenants': {
      id: '/radiant/tenants'
      path: '/tenants'
      fullPath: '/radiant/tenants'
      preLoaderRoute: typeof RadiantTenantsRouteImport
      parentRoute: typeof RadiantRoute
    }
    '/$orgId/settings': {
      id: '/$orgId/settings'
      path: '/settings'
      fullPath: '/$orgId/settings'
      preLoaderRoute: typeof OrgIdSettingsRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/search': {
      id: '/$orgId/search'
      path: '/search'
      fullPath: '/$orgId/search'
      preLoaderRoute: typeof OrgIdSearchRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/reports': {
      id: '/$orgId/reports'
      path: '/reports'
      fullPath: '/$orgId/reports'
      preLoaderRoute: typeof OrgIdReportsRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/onboarding': {
      id: '/$orgId/onboarding'
      path: '/onboarding'
      fullPath: '/$orgId/onboarding'
      preLoaderRoute: typeof OrgIdOnboardingRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/inbox': {
      id: '/$orgId/inbox'
      path: '/inbox'
      fullPath: '/$orgId/inbox'
      preLoaderRoute: typeof OrgIdInboxRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/fleet': {
      id: '/$orgId/fleet'
      path: '/fleet'
      fullPath: '/$orgId/fleet'
      preLoaderRoute: typeof OrgIdFleetRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/commissioning': {
      id: '/$orgId/commissioning'
      path: '/commissioning'
      fullPath: '/$orgId/commissioning'
      preLoaderRoute: typeof OrgIdCommissioningRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/analyze': {
      id: '/$orgId/analyze'
      path: '/analyze'
      fullPath: '/$orgId/analyze'
      preLoaderRoute: typeof OrgIdAnalyzeRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/analyze/': {
      id: '/$orgId/analyze/'
      path: '/'
      fullPath: '/$orgId/analyze/'
      preLoaderRoute: typeof OrgIdAnalyzeIndexRouteImport
      parentRoute: typeof OrgIdAnalyzeRoute
    }
    '/radiant/tenants/new': {
      id: '/radiant/tenants/new'
      path: '/new'
      fullPath: '/radiant/tenants/new'
      preLoaderRoute: typeof RadiantTenantsNewRouteImport
      parentRoute: typeof RadiantTenantsRoute
    }
    '/radiant/tenants/$id': {
      id: '/radiant/tenants/$id'
      path: '/$id'
      fullPath: '/radiant/tenants/$id'
      preLoaderRoute: typeof RadiantTenantsIdRouteImport
      parentRoute: typeof RadiantTenantsRoute
    }
    '/$orgId/sites/new': {
      id: '/$orgId/sites/new'
      path: '/sites/new'
      fullPath: '/$orgId/sites/new'
      preLoaderRoute: typeof OrgIdSitesNewRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/sensors/new': {
      id: '/$orgId/sensors/new'
      path: '/sensors/new'
      fullPath: '/$orgId/sensors/new'
      preLoaderRoute: typeof OrgIdSensorsNewRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/sensors/$id': {
      id: '/$orgId/sensors/$id'
      path: '/sensors/$id'
      fullPath: '/$orgId/sensors/$id'
      preLoaderRoute: typeof OrgIdSensorsIdRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/assets/new': {
      id: '/$orgId/assets/new'
      path: '/assets/new'
      fullPath: '/$orgId/assets/new'
      preLoaderRoute: typeof OrgIdAssetsNewRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/assets/$id': {
      id: '/$orgId/assets/$id'
      path: '/assets/$id'
      fullPath: '/$orgId/assets/$id'
      preLoaderRoute: typeof OrgIdAssetsIdRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/analyze/sessions': {
      id: '/$orgId/analyze/sessions'
      path: '/sessions'
      fullPath: '/$orgId/analyze/sessions'
      preLoaderRoute: typeof OrgIdAnalyzeSessionsRouteImport
      parentRoute: typeof OrgIdAnalyzeRoute
    }
    '/$orgId/alerts/$id': {
      id: '/$orgId/alerts/$id'
      path: '/alerts/$id'
      fullPath: '/$orgId/alerts/$id'
      preLoaderRoute: typeof OrgIdAlertsIdRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/admin/users': {
      id: '/$orgId/admin/users'
      path: '/admin/users'
      fullPath: '/$orgId/admin/users'
      preLoaderRoute: typeof OrgIdAdminUsersRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/admin/roles': {
      id: '/$orgId/admin/roles'
      path: '/admin/roles'
      fullPath: '/$orgId/admin/roles'
      preLoaderRoute: typeof OrgIdAdminRolesRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/admin/org': {
      id: '/$orgId/admin/org'
      path: '/admin/org'
      fullPath: '/$orgId/admin/org'
      preLoaderRoute: typeof OrgIdAdminOrgRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/admin/groups': {
      id: '/$orgId/admin/groups'
      path: '/admin/groups'
      fullPath: '/$orgId/admin/groups'
      preLoaderRoute: typeof OrgIdAdminGroupsRouteImport
      parentRoute: typeof OrgIdRoute
    }
    '/$orgId/admin/audit': {
      id: '/$orgId/admin/audit'
      path: '/admin/audit'
      fullPath: '/$orgId/admin/audit'
      preLoaderRoute: typeof OrgIdAdminAuditRouteImport
      parentRoute: typeof OrgIdRoute
    }
  }
}

interface OrgIdAnalyzeRouteChildren {
  OrgIdAnalyzeSessionsRoute: typeof OrgIdAnalyzeSessionsRoute
  OrgIdAnalyzeIndexRoute: typeof OrgIdAnalyzeIndexRoute
}

const OrgIdAnalyzeRouteChildren: OrgIdAnalyzeRouteChildren = {
  OrgIdAnalyzeSessionsRoute: OrgIdAnalyzeSessionsRoute,
  OrgIdAnalyzeIndexRoute: OrgIdAnalyzeIndexRoute,
}

const OrgIdAnalyzeRouteWithChildren = OrgIdAnalyzeRoute._addFileChildren(
  OrgIdAnalyzeRouteChildren,
)

interface OrgIdRouteChildren {
  OrgIdAnalyzeRoute: typeof OrgIdAnalyzeRouteWithChildren
  OrgIdCommissioningRoute: typeof OrgIdCommissioningRoute
  OrgIdFleetRoute: typeof OrgIdFleetRoute
  OrgIdInboxRoute: typeof OrgIdInboxRoute
  OrgIdOnboardingRoute: typeof OrgIdOnboardingRoute
  OrgIdReportsRoute: typeof OrgIdReportsRoute
  OrgIdSearchRoute: typeof OrgIdSearchRoute
  OrgIdSettingsRoute: typeof OrgIdSettingsRoute
  OrgIdIndexRoute: typeof OrgIdIndexRoute
  OrgIdAdminAuditRoute: typeof OrgIdAdminAuditRoute
  OrgIdAdminGroupsRoute: typeof OrgIdAdminGroupsRoute
  OrgIdAdminOrgRoute: typeof OrgIdAdminOrgRoute
  OrgIdAdminRolesRoute: typeof OrgIdAdminRolesRoute
  OrgIdAdminUsersRoute: typeof OrgIdAdminUsersRoute
  OrgIdAlertsIdRoute: typeof OrgIdAlertsIdRoute
  OrgIdAssetsIdRoute: typeof OrgIdAssetsIdRoute
  OrgIdAssetsNewRoute: typeof OrgIdAssetsNewRoute
  OrgIdSensorsIdRoute: typeof OrgIdSensorsIdRoute
  OrgIdSensorsNewRoute: typeof OrgIdSensorsNewRoute
  OrgIdSitesNewRoute: typeof OrgIdSitesNewRoute
}

const OrgIdRouteChildren: OrgIdRouteChildren = {
  OrgIdAnalyzeRoute: OrgIdAnalyzeRouteWithChildren,
  OrgIdCommissioningRoute: OrgIdCommissioningRoute,
  OrgIdFleetRoute: OrgIdFleetRoute,
  OrgIdInboxRoute: OrgIdInboxRoute,
  OrgIdOnboardingRoute: OrgIdOnboardingRoute,
  OrgIdReportsRoute: OrgIdReportsRoute,
  OrgIdSearchRoute: OrgIdSearchRoute,
  OrgIdSettingsRoute: OrgIdSettingsRoute,
  OrgIdIndexRoute: OrgIdIndexRoute,
  OrgIdAdminAuditRoute: OrgIdAdminAuditRoute,
  OrgIdAdminGroupsRoute: OrgIdAdminGroupsRoute,
  OrgIdAdminOrgRoute: OrgIdAdminOrgRoute,
  OrgIdAdminRolesRoute: OrgIdAdminRolesRoute,
  OrgIdAdminUsersRoute: OrgIdAdminUsersRoute,
  OrgIdAlertsIdRoute: OrgIdAlertsIdRoute,
  OrgIdAssetsIdRoute: OrgIdAssetsIdRoute,
  OrgIdAssetsNewRoute: OrgIdAssetsNewRoute,
  OrgIdSensorsIdRoute: OrgIdSensorsIdRoute,
  OrgIdSensorsNewRoute: OrgIdSensorsNewRoute,
  OrgIdSitesNewRoute: OrgIdSitesNewRoute,
}

const OrgIdRouteWithChildren = OrgIdRoute._addFileChildren(OrgIdRouteChildren)

interface RadiantTenantsRouteChildren {
  RadiantTenantsIdRoute: typeof RadiantTenantsIdRoute
  RadiantTenantsNewRoute: typeof RadiantTenantsNewRoute
}

const RadiantTenantsRouteChildren: RadiantTenantsRouteChildren = {
  RadiantTenantsIdRoute: RadiantTenantsIdRoute,
  RadiantTenantsNewRoute: RadiantTenantsNewRoute,
}

const RadiantTenantsRouteWithChildren = RadiantTenantsRoute._addFileChildren(
  RadiantTenantsRouteChildren,
)

interface RadiantRouteChildren {
  RadiantTenantsRoute: typeof RadiantTenantsRouteWithChildren
}

const RadiantRouteChildren: RadiantRouteChildren = {
  RadiantTenantsRoute: RadiantTenantsRouteWithChildren,
}

const RadiantRouteWithChildren =
  RadiantRoute._addFileChildren(RadiantRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrgIdRoute: OrgIdRouteWithChildren,
  AuthRoute: AuthRoute,
  InviteRoute: InviteRoute,
  RadiantRoute: RadiantRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
